import React from 'react';
import { formatDate } from './dateHelpers';


interface DateCellProps {
  value: string | null | undefined;
}

interface TableRowData {
  Status?: string;
  'Well Status'?: string;
  [key: string]: any;
}

interface StatusCellProps {
  value?: string;
  row?: {
    original?: TableRowData;
  };
}

const STATUS_CLASSES = {
  running: 'completion-status-badge running',
  pulled: 'completion-status-badge pulled',
  failed: 'completion-status-badge failed',
  excluded: 'completion-status-badge excluded',
  default: 'completion-status-badge',
} as const;

const EMPTY_CELL = <span>-</span>;

// Formats a date value to standardized application format
export const formatDateCell = React.memo(({ value }: DateCellProps) => {
  return <span>{formatDate(value)}</span>;
});

formatDateCell.displayName = 'FormatDateCell';

// Gets the appropriate status class based on status value
const getStatusClass = (status: string): string => {
  const normalizedStatus = status.toLowerCase();

  if (normalizedStatus.includes('running')) return STATUS_CLASSES.running;
  if (normalizedStatus.includes('pulled')) return STATUS_CLASSES.pulled;
  if (normalizedStatus.includes('failed')) return STATUS_CLASSES.failed;
  if (normalizedStatus.includes('excluded')) return STATUS_CLASSES.excluded;

  return STATUS_CLASSES.default;
};

// Formats a status cell with appropriate CSS classes
export const formatStatusCell = React.memo((props: StatusCellProps) => {
  let value = props.value;

  if (!value && props.row?.original) {
    value = props.row.original.Status || props.row.original['Well Status'];
  }

  if (!value) return EMPTY_CELL;

  return <span className={getStatusClass(value)}>{value}</span>;
});

formatStatusCell.displayName = 'FormatStatusCell';
